// eslint-disable-next-line no-unused-vars
import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { registerUser, userOtp } from "../../services/authFn";
import { useAuth } from "../../context/AuthContext";
import AppLoader from "../loader/loader";

function Otp() {
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state;
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const { loginUserId } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let countdown;
    if (timer > 0 && isResendDisabled) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendDisabled(false);
    }

    return () => clearInterval(countdown);
  }, [timer, isResendDisabled]);
  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    if (e.target.value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  // Handle OTP submission
  const handleSubmit = async () => {
    const otpCode = otp.join(""); // Combine OTP digits into a single string
    if (otpCode.length !== 4) {
      return showAlert("error", "Please enter a valid 4-digit OTP.");
    }

    const payload = {
      ...userData,
      otp: otpCode,
      role: "User",
      purpose: "Registration",
    };

    try {
      setIsLoading(true);
      const response = await userOtp(payload);
      if (response?.data?.status === "success") {
        let data = response?.data?.data.user;
        console.log("User data from OTP verification:", data);
        loginUserId({ _id: data?._id, email: data?.email });
        showAlert("Success", "OTP Verified Successfully!", "success");
        navigate("/subplans");
      } else {
        showAlert(
          "Error",
          response?.data.message || "OTP verification failed.",
          "error"
        );
      }
    } catch (error) {
      showAlert(
        "Error",
        error?.message || "An error occurred during OTP verification.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleResendOtp = async () => {
    if (isResendDisabled) return;

    const payload = {
      email: userData.email,
      purpose: "Registration",
      role: "User",
    };

    try {
      const response = await registerUser(payload);
      if (response.data.status === "success") {
        setTimer(60);
        setIsResendDisabled(true);
        showAlert("Success", "OTP has been resent successfully!", "success");
      } else {
        showAlert(
          "Error",
          response?.data.message || "Failed to resend OTP.",
          "error"
        );
      }
    } catch (error) {
      showAlert(
        "Error",
        error?.message || "An error occurred while resending OTP.",
        "error"
      );
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="otp-section">
        <div className="hero-otp">
          <div className="container-otp">
            <div className="box-otp">
              <h1 className="otp-pg">OTP Verification</h1>
              <span className="headings-otp">
                <h3>Enter OTP Code</h3>
                <p>
                  Check your email, we have sent you an email with an OTP code.
                </p>
              </span>

              <div className="otp-input">
                <div className="otp-field-container">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      id={`otp-${index}`}
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      maxLength="1"
                      className="otp-field"
                      autoFocus={index === 0}
                      placeholder="-"
                    />
                  ))}
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="btn-otp" onClick={handleSubmit}>
                  Verify
                </button>
              </div>

              {/* Register Link */}
              <div className="register-link">
                <p>
                  didn&apos;t receive the email?{" "}
                  <a onClick={handleResendOtp} style={{ cursor: "pointer" }}>
                    {isResendDisabled ? `Resend in ${timer}s` : "Resend"}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Otp;
